import { render, staticRenderFns } from "./DetalleRecepcionInfoModal.vue?vue&type=template&id=0bd49e95&"
import script from "./DetalleRecepcionInfoModal.vue?vue&type=script&lang=js&"
export * from "./DetalleRecepcionInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports